<template>
	<section>
		<div v-if="items.main_visual_type == 'slider'" class="iv2-hero position-relative overflow-hidden">
			<div v-for="media in items.main_visuals" :key="media.id" class="iv2-hero-slider">
				<transition name="slider-fade">
					<div v-if="current_slide == media.sort_key" class="iv2-hero-inner">
						<picture>
							<source type="image/webp" :srcset="media.file_url + $t('general.image_webp')">
							<img class="iv2-hero-image" :src="media.file_url" :alt="media.catchphrase_text">
						</picture>
						<div
							class="iv2-hero--color position-absolute"
							:style="{ 'background-color': color, opacity: opacity }"
						>
							<a
								v-if="media.use_link == 1 && media.is_external == 0"
								:href="media.link_href"
								target="_self"
								class="iv2-hero-link d-block w-100 h-100"
							></a>
							<a
								v-else-if="media.use_link == 1 && media.is_external == 1"
								:href="media.link_href"
								target="_blank"
								class="iv2-hero-link d-block w-100 h-100"
							></a>
						</div>
						<div class="iv2-hero-text position-absolute text-center">
							<a
								v-if="media.use_link == 1 && media.is_external == 0"
								:href="media.link_href"
								target="_self"
								class="iv2-hero-link position-absolute d-block w-100 h-100"
							></a>
							<a
								v-if="media.use_link == 1 && media.is_external == 1"
								:href="media.link_href"
								target="_blank"
								class="iv2-hero-link position-absolute d-block w-100 h-100"
							></a>
							<div class="row">
								<div class="col-md-12 ml-auto mr-auto text-center">
									<h2 v-if="media.catchphrase_text !== null" v-html="media.catchphrase_text" class="iv2-hero__main-title"></h2>
									<h3 v-if="media.summary_text !== null" v-html="media.summary_text" class="iv2-hero__sub-title"></h3>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
		<div
			v-else-if="items.main_visual_type == 'movie'"
			class="iv2-hero overflow-hidden position-relative"
		>
			<video class="iv2-hero-video fit-img" autoplay muted loop playsinline>
				<source :src="data.file_url" type="video/mp4" />
			</video>

			<div
				class="iv2-hero--color position-absolute"
				:style="{'background-color': color,opacity: opacity,}"
			></div>
			<div class="iv2-hero-text position-absolute">
				<div class="row">
					<div class="col-md-12 ml-auto mr-auto text-center">
						<h2 v-if="data.catchphrase_text !== null" v-html="data.catchphrase_text" class="iv2-hero__main-title"></h2>
						<h3 v-if="data.summary_text !== null" v-html="data.summary_text" class="iv2-hero__sub-title"></h3>
					</div>
					<div v-if="data.use_button == 1" class="w-100 mt-5 text-center">
						<span>
							<a
								:href="data.link_href"
								:target="windowSelected"
								class="iv2-hero-btn theme__main-btn is-btn is-btn-ghost2 size-18"
							>{{ data.button_label }}</a>
						</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "LayoutHero",

	props: ["items"],

	data() {
		return {
			current_slide: 1,
			color: "#000000",
			opacity: 0.1,
			windowSelected: "",
			data:{}
		};
	},

	created() {
		if (this.items.main_visuals[0].is_external === 1) {
			this.windowSelected = "_blank";
		} else {
			this.windowSelected = "_self";
		}
		if(this.items.main_visual_type == 'movie') {
			this.data = this.items.main_visuals[0]
		}
	},

	mounted() {
		if(this.items.main_visual_type == 'slider') {
			setInterval(() => {
				this.current_slide = this.current_slide < this.items.main_visuals.length ? this.current_slide +1 : 1
			}, 6000)
		}
    }
};
</script>

<style lang="scss">
.slider-fade-enter-active,
.slider-fade-leave-active {
  transition: opacity 1s;
//   transform: scale(1.03);
}
.slider-fade-enter,
.slider-fade-leave-to {
  opacity: 0;
}

.iv2-hero {
	background-color: #000000;
	height: 100vh;

	.iv2-hero-slider {
		position: absolute;
		width: 100%;
		height: 100%;

		.iv2-hero-inner {
			width: 100%;
			height: 100%;
		
			.iv2-hero-image {
				margin: 0 !important;
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}
	}

	.iv2-hero-video {
		margin: 0 !important;
		height: 100%;
		width: 100%;
		object-fit: cover;
	}

	.iv2-hero--color {
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 3;
	}

	.iv2-hero-link {
		cursor: pointer;
		z-index: 3;
	}

	.iv2-hero-text {
		width: 90%;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		margin: auto;
		color: #ffffff;
		z-index: 2;
		animation-name: fade;
		animation-duration: 4s;
		text-shadow: 0px -1px 10px #00000085;
	}

	.iv2-hero-btn {
		max-width: 100%;
	}

	@keyframes fade {
		0% {
			opacity: 0;
		}
		20% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-hero {
		.iv2-hero__main-title {
			font-size: 4rem;
		}

		.iv2-hero__sub-title {
			font-size: 1.5rem;
		}
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-hero {
		.iv2-hero-text {
			.iv2-hero__sub-title {
				font-size: 1rem;
			}
		}
	}
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-hero {
		height: calc(100vh - 75px);

		.iv2-hero-text {
			.iv2-hero__main-title {
				font-size: 3.5rem;
			}
		}
	}
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-hero {
		height: calc(100vh - 120px);

		.iv2-hero-text {
			.iv2-hero__main-title {
				font-size: 2rem;
			}
		}
	}
}
</style>
